const reportsMenu = [
  {
    System: 'RPT',
    isActive: false,
    menu: [
      { is_header: true, title: 'Reports_Management', isActive: true }, // عنوان النظام العام

      {
        path: '/RPT/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      {
        path: '/RPT/Reports',
        icon: 'fas fa-chart-line', // أيقونة إدارة التقارير
        title: 'Reports_Management',
        permission: 'NtxViewReportslist',
        isActive: true
      },
      {
        path: '/RPT/NtxDashboardManagement',
        icon: 'fas fa-tachometer-alt', // أيقونة إدارة لوحة البيانات
        title: 'DashboardManagement',
        permission: 'NtxViewDashboardslist',
        isActive: true
      },
      { is_header: true, title: 'ManagingPrintingTemplates', isActive: true },
      {
        path: '/RPT/PrintingForms',
        icon: 'fas fa-print', // أيقونة إدارة قوالب الطباعة
        title: 'ManagingPrintingTemplates',
        permission: 'NtxViewPrintingFormsList',
        isActive: true
      },

      {
        path: '/RPT/PrintingFormsLetter',
        icon: 'fas fa-print',
        title: 'LetterManagement',
        permission: 'NtxViewPrintingFormsLettersList',
        isActive: true
      }
    ]
  }
];

export default reportsMenu;
